/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-link-library-modal.component.html';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';
import {StateService} from '@uirouter/core';

export interface CreativeLinkLibraryModalResult {
  destination: boolean;
  creativeId: string;
}

@Component({
  standalone: false,
  selector: 'adn-creative-link-library-modal',
  template
})
export class CreativeLinkLibraryModalComponent implements OnInit {
  model: any;
  modelComms: any;
  onComplete: (result: CreativeLinkLibraryModalResult) => void;

  libraryCreative: any;
  destination = true;
  disabled = false;
  validationErrors: any[] = [];

  private creative: any;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any,
    private readonly $state: StateService
  ) {
  }

  ngOnInit(): void {
    this.creative = this.model;
    if (this.modelComms) {
      this.modelComms.addSubscriber((data: any, type: any) => {
        if (!type) {
          this.creative = data;
        }
      });
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  linkCreative(): void {
    this.disabled = true;
    this.validationErrors = [];
    this.adnModalLoading.applyModalLoading();

    this.creative.libraryCreative = this.libraryCreative;

    this.creative.savePartial(['name', 'libraryCreative']).then((creative: any) => {
      this.disabled = false;
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.({destination: this.destination, creativeId: creative.id});
      this.bsModalRef.hide();
      if (creative.id) {
        this.$state.go('app.adv.creatives.creative', {id: creative.id, isNew: false}, {reload: true});
      }
    }, (errors: any) => {
      this.disabled = false;
      this.validationErrors = _.get(errors, ['data', 'errors'], []);
      this.adnModalLoading.removeModalLoading();
    });
  }
}
